import {Skeleton, Stack, Typography} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';

const {serviceType} = translations['pt-br'].privateFlow.guideFlow;

export function ServiceCardsSkeleton() {
	const {isMobile} = useMediaQueries();

	return (
		<Stack gap={1}>
			<Typography variant="body2" fontWeight={600} color="text.secondary">
				{serviceType}
			</Typography>
			<StyledGrid.Root spacing={1}>
				{Array.from({length: 4}).map((_, index) => (
					<StyledGrid.Item key={index} xs={isMobile ? 12 : 6} sm={4} md={4} lg={4} xl={3}>
						<Skeleton variant="rectangular" height={64} sx={{borderRadius: 1}} />
					</StyledGrid.Item>
				))}
			</StyledGrid.Root>
		</Stack>
	);
}
